function removeBgClasses(element) {
  const classes = element.className.split(' ');
  const newClasses = classes.filter(className => !className.startsWith('bg-'));
  element.className = newClasses.join(' ');
}
// Función para mostrar el div correspondiente y ocultar los demás
function showDiv(index, bg_color_button) {
    const divs = document.querySelectorAll('.interna_producto_plan-div-content');
    const buttons = document.querySelectorAll('.interna_producto_plan-div-button');
    divs.forEach((div, i) => {
      if (i === index) {
        div.classList.remove('hidden');
        buttons[i].classList.add("bg-[" + bg_color_button + "]");
      } else {
        div.classList.add('hidden');
        removeBgClasses(buttons[i]);
      }
    });
  }